import styled from 'styled-components';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { Col, Row } from '../../../common/components/layout/FlexLayout';
import { PageSection } from '../../../common/components/layout/PageSection/PageSection';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { Breakpoint } from '../../../common/styles/constants';

export const HealthcareProviderPageSection = styled(PageSection)`
  background-color: ${ThemeColours.white};
`;

export const HealthcareProviderGraphic = styled(HeImgix)`
  height: 350px;
  width: auto;

  ${Breakpoint.MEDIUM} {
    height: 436px;
  }
`;

export const HealthcareProviderSectionLeftCol = styled(Col)`
  align-items: center;
  margin-bottom: 42px;

  ${Breakpoint.MEDIUM} {
    height: 436px;
    margin-bottom: 0px;
  }
`;

export const HealthcareProviderSectionRightCol = styled(Col)`
  align-items: flex-start;
  justify-content: center;
`;

export const HealthcareProviderSectionRow = styled(Row)`
  flex-direction: column;

  ${Breakpoint.MEDIUM} {
    flex-direction: row;
  }
`;
